import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Pasta = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Пасти'/>
            <main className={s.main}>
                <Product name='Карбонара' weight='300г.' price='120 грн.' info1='спагетті, бекон копчений, яйця курячі, вершки, пармезан, масло, часник, кунжут чорний, сіль, перець'/>
                <Product name='4 Сири' weight='300г.' price='150 грн.' info1='спагетті, вершки, моцарела, сир Дана-блю, памезам, сир Київський, петрушка, сіль'/>
                <Product name='З соусом Теріякі' weight='300г.' price='120 грн.' info1='спагетті, філе куряче, перець солодкий червоний, помідори, спаржа, масло, соус "Теріякі", сіль, перець, петрушка, кунжут'/>
                <Product name='З печерицями' weight='300г.' price='130 грн.' info1='Спагетті, філе куряче, печериці, сир Пармезан, масло, вершки, сіль, перець чорний мелений, петрушка'/>
                <Product name='Болоньєзе' weight='300г.' price='130 грн.' info1='спагетті, фарш свинячий, цибуля, масло, часник, пармезан, сіль, перець, італійські трави, томатна паста'/>
            </main>
        </div>
    )
}

export default Pasta;